import Screen1 from "../images/screen1.jpg";
import Screen2 from "../images/screen2.jpg";
import Screen3 from "../images/screen3.jpg";
import Screen4 from "../images/screen4.jpg";
import Screen5 from "../images/screen5.jpg";
import Screen6 from "../images/screen6.jpg";

import { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import "./CarouselScreenshots.css";

function CarouselScreenshots() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="col-12 text-center shadow">
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        fade={true}
        variant={"dark"}
        interval={2000}
      >
        <Carousel.Item>
          <img
            className="d-block w-100 h-200"
            src={Screen1}
            alt="First slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 h-200"
            src={Screen2}
            alt="Second slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 h-200"
            src={Screen3}
            alt="Third slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 h-200"
            src={Screen4}
            alt="Fourth slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 h-150"
            src={Screen5}
            alt="Fifth slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 h-150"
            src={Screen6}
            alt="Fifth slide"
          />
        </Carousel.Item>
      </Carousel>
    </div>
  );
}

export default CarouselScreenshots;
